const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Retorna la URL completa para descarga directa de un archivo.
 * Usar en <a href={getPdfUrl(url)} target="_blank">
 */
export const getPdfUrl = (url) => {
  if (!url) return "#";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
};

/**
 * Abre un PDF en nueva pestaña. Para uso en onClick handlers.
 * NOTA: Puede ser bloqueado por popup blockers en mobile si se llama después de await.
 * Preferir <a href> cuando sea posible.
 */
export const descargarArchivo = (url) => {
  const fullUrl = getPdfUrl(url);
  window.open(fullUrl, "_blank");
};
